import { NgModule } from '@angular/core';
import { RouteReuseStrategy, RouterModule, Routes } from '@angular/router';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { AuthenticationGuard } from './core/services/authentication.guard';
import { HomeRedirectGuard } from './core/services/home-redirect.guard';
import { MultipleHospitalsGuard } from './core/services/multiple-hospitals.guard';
import { CustomReuseStrategy } from './custom-reuse-strategy';
import { ANESTHETIST } from './shared/const/globals.const';
// import { BLOCK_MANAGER } from './shared/const/positions.const';
const routes: Routes = [
  {
    path: 'authentication',
    loadChildren: () => import('./authentication/authentication.module').then((m: any) => m.AuthenticationModule),
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
  },
  {
    path: '',
    canActivate: [HomeRedirectGuard],
    children: [],
  },
  {
    path: 'home',
    canActivate: [HomeRedirectGuard],
    children: [],
  },
  {
    path: 'hrsuite',
    loadChildren: () => import('./hrsuite/hrsuite.module').then((m) => m.HrsuiteModule),
    canActivate: [AuthenticationGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'operatingschedule',
    loadChildren: () => import('./operatingschedule/operatingschedule.module').then((m) => m.OperatingscheduleModule),
    canActivate: [AuthenticationGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'profiles',
    loadChildren: () => import('./account/account.module').then((m) => m.AccountModule),
    canActivate: [AuthenticationGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'profile',
    loadChildren: () => import('./my-account/my-account.module').then((m) => m.MyAccountModule),
    canActivate: [AuthenticationGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'smart-planning',
    loadChildren: () => import('./smart-planning/smart-planning.module').then((m) => m.SmartPlanningModule),
    canActivate: [AuthenticationGuard],
    runGuardsAndResolvers: 'always',
    pathMatch: 'prefix',
  },
  {
    path: 'statop',
    loadChildren: () => import('./statop/statop.module').then((m) => m.StatopModule),
    canActivate: [AuthenticationGuard],
    runGuardsAndResolvers: 'always',
    pathMatch: 'prefix',
    data: {
      positions: [ANESTHETIST],
    },
  },
  {
    path: 'parcours-ibode',
    loadChildren: () => import('./parcours-ibode/parcours-ibode.module').then((m) => m.ParcoursIbodeModule),
    canActivate: [AuthenticationGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'about',
    loadChildren: () => import('./about/about.module').then((m) => m.AboutModule),
    canActivate: [AuthenticationGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'configuration',
    loadChildren: () => import('./configuration/configuration.module').then((m) => m.ConfigurationModule),
    canActivate: [AuthenticationGuard],
    runGuardsAndResolvers: 'always',
    pathMatch: 'prefix',
  },
  {
    path: 'messagerie',
    loadChildren: () => import('./messaging/messaging.module').then((m) => m.MessagingModule),
    canActivate: [AuthenticationGuard, MultipleHospitalsGuard],
    canDeactivate: [MultipleHospitalsGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'pending-requests',
    loadChildren: () => import('./pending-request/pending-request.module').then((m) => m.PendingRequestModule),
    canActivate: [AuthenticationGuard],
    runGuardsAndResolvers: 'always',
  },
  { path: '**', redirectTo: 'home' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'ignore' })],
  providers: [{ provide: RouteReuseStrategy, useClass: CustomReuseStrategy }],
  exports: [RouterModule],
})
export class AppRoutingModule {}
